export default class StickyNav {
    constructor() {
        this.bindUIActions();
    }

    bindUIActions() {
        const $nav = $('.js-navbar-fixed');
        const $uspNav = $('.js-header-usp');

        const isCheckoutPage = $('body').hasClass('woocommerce-checkout');
        const isOrderConfirmationPage = $('body').hasClass('woocommerce-order-received');
        if (!isCheckoutPage || (isCheckoutPage && isOrderConfirmationPage)) {
            $uspNav.css('margin-top', $('.js-navbar-fixed').height());
            $nav.addClass('top-0');
        }
        
        let lastScrollTop = 0;

        if (!isCheckoutPage || (isCheckoutPage && isOrderConfirmationPage)) {
            $uspNav.css('margin-top', $('.js-navbar-fixed').height());
        }

        $(document).scroll(function () {
            const $nav = $('.js-navbar-fixed');
            const $mainLogo = $('.js-navbar-logo');
            const $secondaryLogo = $('.js-navbar-logo-sticky');
            const $headerTrustpilot = $('.js-header-trustpilot');
            const $headerKlarna = $('.js-header-klarna');
            const $st = $(this).scrollTop();
            const $headerHeight = $nav.height();

            // If the scrolltop is greater than the header height, fade out the navbar logos and replace with the sticky logo
            if ($st > lastScrollTop && $st > $headerHeight) {
                $mainLogo.removeClass('fade-in-quick').addClass('fade-out-quick');
                $secondaryLogo.addClass('fade-in-quick').removeClass('fade-out-quick');
                $nav.css('top', '0');
                $headerTrustpilot.addClass('fade-in-quick').removeClass('fade-out-quick');
                $headerKlarna.addClass('fade-in-quick').removeClass('fade-out-quick');

            } else if ($st < lastScrollTop && $st <= $headerHeight) {
                $mainLogo.removeClass('fade-out-quick').addClass('fade-in-quick');
                $secondaryLogo.addClass('fade-out-quick').removeClass('fade-in-quick');
                $nav.css('margin-top', '0');
                $headerTrustpilot.addClass('fade-out-quick').removeClass('fade-in-quick');
                $headerKlarna.addClass('fade-out-quick').removeClass('fade-in-quick');
            }

            lastScrollTop = $st;
        });
    }
}

new StickyNav();
